import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/chevron_right.svg?url_encode")